//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createHouseType, deleteHouseType, getHouseTypeList } from '../../../api/project';
import fileUploader from '../../common-components/file-uploader';

export default {
    name: 'project-houseType-view',
    components: {
        fileUploader
    },
    props: {
        projectId: {
            type: Number, required: true
        }
    },
    data() {
        const vm = this;
        return {
            saving: false,
            loading: false,
            houseTypes: [],
            houseTypesColumns: [
                { type: 'index', width: 60, align: 'center' },
                { title: '名称', minWidth: 150, maxWidth: 200, align: 'center', key: 'name' },
                { title: '图片', minWidth: 120, slot: 'image', align: 'center' },
                { title: '操作', minWidth: 120, slot: 'actions', align: 'center' }
            ],
            createHouseTypeModal: false,
            createHouseTypeDto: {
                image: {}
            }
        };
    },
    computed: {
        projectInfo() {
            return this.$store.state.project.projectInfo;
        }
    },
    methods: {
        getHouseTypeList() {
            this.loading = true;
            getHouseTypeList(this.projectId).then(res => {
                this.houseTypes = [];
                this.houseTypes.push(...res.data.result);
            }).finally(() => {
                this.loading = false;
            });
        },
        onSaveCreateHouseType() {
            if (!this.createHouseTypeDto.name) {
                this.$Message.error('请输入户型名称');
                return;
            }

            this.createHouseTypeDto.projectId = this.projectId;
            this.saving = true;
            createHouseType(this.createHouseTypeDto).then(res => {
                this.$Notice.success({
                    duration: 3,
                    title: '保存成功'
                });
                this.createHouseTypeModal = false;
                this.getHouseTypeList();
            }).finally(() => {
                this.saving = false;
            });
        },
        onCancelCreateHouseType() {
            this.createHouseTypeDto = {
                image: {}
            };
            this.createHouseTypeModal = false;
        },
        showCreateHouseTypeModal(row) {
            this.createHouseTypeDto = {
                image: {}
            };
            this.createHouseTypeDto = JSON.parse(JSON.stringify(row));
            this.createHouseTypeDto.image = {};
            this.createHouseTypeModal = true;
        },
        onDelHouseType(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + row.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: () => {
                    deleteHouseType(row.id).then(res => {
                        this.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        vm.createHouseTypeModal = false;
                        vm.getHouseTypeList();
                    });
                }
            });
        }
    },
    created() {
        this.getHouseTypeList();
    }
};
